module.exports = __webpack_public_path__ + "img/yaplay_white.a5ff5248.png";